export const designatedCoach = {
  DESIGNATED: 1,
  NON_DESIGNATED: 0,
};
